function collapseSection(sectionId) {
  const productListBox = document.getElementById(`productListBox--${sectionId}`);
  const collapseIcon = document.querySelector(`.collapse-icon--${sectionId}`);

  if (collapseIcon) {
    if (productListBox.classList.contains("hide-selected-section")) {
      collapseIcon.style.transform = "rotate(0deg)";
    } else {
      collapseIcon.style.transform = "rotate(180deg)";
    }
  }
  if (productListBox) {
    if (productListBox.classList.contains("hide-selected-section")) {
      productListBox.classList.remove("hide-selected-section");
    } else {
      productListBox.classList.add("hide-selected-section");
    }
  }
}

function goCheckout() {
    setButtonLoadDots("buttonLoadCheckoutESQ")
    setTimeout(() => window.location.href = '/checkout', 1000)
}

